import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';

interface TagEntryButtonProps {
  onClick: (e) => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
  isHidden?: boolean;
  isTagReadOnly?: boolean;
  isFilesTable?: boolean;
  isLibrary?: boolean;
}

// Add tag button if no assigned tags is selected
const TagEntryButton: React.FC<TagEntryButtonProps> = ({
  onClick,
  buttonRef,
  isTagReadOnly,
  isHidden,
  isFilesTable = false,
  isLibrary = false,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const onButtonClick = (e) => {
    if (isTagReadOnly) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick(e);
  };

  const showOnHover =
    isHidden || isTagReadOnly ? 0 : isFilesTable || isLibrary ? (isHovered ? 1 : 0) : 1;

  return (
    <button
      ref={buttonRef}
      className={clsx(
        'tw-flex tw-justify-center',
        'tw-items-center',
        'tw-bg-cfo-white',
        'tw-text-cfo-blue-600',
        'tw-px-4',
        'tw-py-1',
        'tw-rounded-full',
        'tw-shadow',
        'hover:tw-bg-blue-600',
        'hover:tw-text-white',
        'focus:tw-outline-none',
        'focus:tw-ring-2',
        'focus:tw-ring-blue-300',
        'tw-w-[60px]',
        'tw-text-center',
        'tw-border-solid tw-border-cfo-blue-700 tw-border-[1px]',
        isTagReadOnly && 'tw-pointer-events-none'
      )}
      onClick={onButtonClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        opacity: showOnHover,
        transition: 'opacity 0.2s',
      }}
    >
      <Icon icon={ICONS.add} className="tw-text-[16px]" />
      <span className="tw-font-brandonTextRegular">Tags</span>
    </button>
  );
};

export default TagEntryButton;
